import { useNavigate } from "react-router-dom";
import "../../styles/pagesStyles/home.css";
import FadeType from "../../animation/Animation";
import { BsArrowRight, BsArrowUp } from "react-icons/bs";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
const HomeImgComp = ({ home_c_img, homeimg, id, to, btn, className }) => {
  const navigate = useNavigate();

  const handleClick = () => {

    // let scrollContainer = document.querySelector(".home_image___scroll");
    const targetElement = document.getElementById("home_c_img4")
  
    const scrollToHere = targetElement.offsetLeft + window.innerWidth + 190;
  
    console.log(scrollToHere)
  
    gsap.to(window, {
      scrollTo: scrollToHere,
      duration: 0.2
    })
  }

  return (
      <div id={home_c_img} className={`${home_c_img} ${className}`}>
        <img src={homeimg} alt="home" />
        <FadeType wrapperElement="button" onClick={() => navigate(`${to}`)}>
          {btn}
        </FadeType>
        {home_c_img === "home_c_img3" ?
          <div className="scroll_container_right scroll_position">
            <button className="scroll_btn" onClick={handleClick}>
              <BsArrowRight className="scroll_arrow" />
            </button>
            <p className="scroll_text">Scroll</p>
          </div>
          :
          <div className="scroll_container scroll_position">
            <button className="scroll_btn" onClick={() => navigate(`#${id}`)}>
              <BsArrowUp className="scroll_arrow" />
            </button>
            <p className="scroll_text">Scroll</p>
          </div>
        }
      </div>
  );
};

export default HomeImgComp;